import { dialogService, toastService } from '@thefarmersfront/kitchen';

import { ExcelUploadModal } from '~/components/common';

import { usePostThirdPartySkuExcelUploadMutation } from '~/hooks/product';

import { FILE_SIZE_LIMIT } from '~/constants';

const infoTexts = [
  '상품 일괄등록은 최대 500건까지만 지원합니다. 초과할 시 서버 부하의 원인이 될 수 있습니다.',
  '최대 10초 정도 소요되니 완료 전까지 브라우저를 종료하지 말아주세요.',
  '일괄등록이 완료되어도 관리자의 확인을 거치고 시스템에 반영됩니다.',
  '업로드에 실패할 경우 실패 사유가 담긴 엑셀파일이 다운로드 되니 수정 후 재업로드 부탁드립니다.',
];

type TypeProductRegisterExcelModal = {
  open: boolean;
  onCancel: () => void | Promise<void>;
  onConfirm: () => void | Promise<void>;
};

const ProductRegisterExcelModal = ({ open, onCancel, onConfirm }: TypeProductRegisterExcelModal) => {
  const excelUploadMutation = usePostThirdPartySkuExcelUploadMutation();

  const requestProductExcelUpload = (file: File) => {
    excelUploadMutation.mutate(file, {
      onSuccess: () => {
        toastService.addToast({
          message: '상품 정보가 등록 요청되었습니다.\n관리자의 확인 후 정식 등록처리 됩니다.',
        });
        onConfirm();
      },
    });
  };

  const handleConfirm = async (file: File) => {
    if (FILE_SIZE_LIMIT < file.size) {
      dialogService.addDialog({
        children: '10MB 이하 파일만 첨부할 수 있습니다.',
      });
      return;
    }

    requestProductExcelUpload(file);
  };

  return (
    <ExcelUploadModal
      title="상품 엑셀 등록"
      infoTexts={infoTexts}
      accept=".xls,.xlsx"
      open={open}
      onCancel={onCancel}
      onConfirm={handleConfirm}
    />
  );
};

export default ProductRegisterExcelModal;
